module.exports = __webpack_public_path__ + "static/media/NodeBookShop_18.7209db6f.webp";